import { Injectable } from "@angular/core";
import { IID_FEASABILITY_RESPONSE } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDFeasabilityResponseStore } from "./iidFeasabilityResponse.store";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { InterfaceDataQuery } from "../interfaceDataRegistry";

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.IID_FEASABILITY_RESPONSE)
export class IIDFeasabilityResponseQuery extends AbstractInterfaceDataQuery<IID_FEASABILITY_RESPONSE> {
  constructor(protected store: IIDFeasabilityResponseStore) {
    super(store);
  }
}
